{
  "error-unable-to-create": "Unable to create task. Please try again later",
  "error-unable-to-update": "Unable to update task. Please try again later",
  "error-unable-to-delete": "Unable to delete task. Please try again later",
  "error-unable-to-reorder": "Unable to reorder task. Please try again later",
  "edit-next-steps": "Edit Tasks",
  "mutual-plan-title": "Mutual plan",
  "client-group-title-advisor": "Client next steps",
  "advisor-group-title-advisor": "Your commitments",
  "client-group-title-client": "Your next steps",
  "advisor-group-title-client": "What your advisor is working on",
  "client-group-empty": "No client next steps yet.",
  "advisor-group-empty": "No advisor commitments yet.",
  "responsibility-label": "Responsible party",
  "responsibility-client": "Client",
  "responsibility-advisor": "Advisor",
  "advisor-completion-disabled": "Only your advisor can complete this commitment."
}
